import axios from 'axios'

export default {
    getCategory() {
        return axios.get('/dev/category ')
    },
    getVideo(v_id) {
        return axios.get('/dev/' + v_id)
    },
    getSearchResults(keyword) {
        return axios.get('dev/search?keyword=' + keyword)
    },
    getByCategory(category_name) {
        return axios.get('/dev/cat/' + category_name)
    },
    getFeatured(limit = 8) {
        return axios.get('/dev/feature?limit=' + limit)
    },
    getNewest(limit = 8) {
        return axios.get('/dev/newest?limit=' + limit)
    },
    sendVideoAnalysis(v_info) {
        return axios.put('https://yf667dahkl.execute-api.ap-northeast-1.amazonaws.com/v1/streams/video-analysis', {
            data: v_info
        })
    },

    clickVideo(v_info) {
        return axios.put('https://yf667dahkl.execute-api.ap-northeast-1.amazonaws.com/v1/streams/click', {
            data: v_info
        })
    }
}